module.exports = __webpack_public_path__ + "static/en-2-78d7585079445b9adac3dd3d1a6cd2aa.png";